import { useState } from "react";
import "./Orders.css";
import { useNavigate } from "react-router-dom";
import { FaPrint } from "react-icons/fa";
import { ORDER_STATUS_ARABIC } from "../constants/orderStatuses";
import {
  getOrderCategoriesTableLabel,
  getOrderCategoriesTitle
} from "../utils/orderCategories";

function Orders({ orders, loading, error, onSearch ,currentPage ,totalPages}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState("order_no");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [activeSearch, setActiveSearch] = useState({
    term: "",
    type: "order_no"
  });
  const navigate = useNavigate()

  const searchOptions = [
    { key: "order_no", label: "رقم الطلب" },
    { key: "name", label: "الاسم" },
    { key: "phone", label: "الهاتف" },
    { key: "location", label: "الموقع" }
  ];

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSelectedStatus("");
    setActiveSearch({
      term: searchTerm,
      type: searchType
    });
    onSearch(searchTerm, searchType, 1);
  };

  const handleStatusSearch = (status) => {
    setSelectedStatus(status);
    setSearchTerm("");
    setActiveSearch({
      term: status,
      type: "status"
    });
    onSearch(status, "status", 1);
  };

  const handleClearSearch = () => {
    setSelectedStatus("");
    setSearchTerm("");
    setActiveSearch({
      term: "",
      type: searchType
    });
    onSearch("", searchType, 1);
  };

  const handlePageChange = (direction) => {
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;
    onSearch(activeSearch.term, activeSearch.type, newPage);
  };
  
  const handleRowClick = (id) => {
    navigate(`/order-details/${id}`); // 👈 الانتقال لصفحة التفاصيل
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="orders-container">
      <h2 className="orders-title">الطلبيات الحالية</h2>

    <div className="search-box">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <div className="input-with-btn">
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            className="orders-search-type"
          >
            {searchOptions.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder={`بحث حسب ${searchOptions.find(o => o.key === searchType)?.label}...`}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setSelectedStatus("");
            }}
            className="orders-search-input"
          />
          <button type="submit" className="search-btn">بحث</button>
        </div>
        
        <div className="status-filter-row">
          <span className="filter-title">الحالة:</span>
          <button
            type="button"
            className={`chip ${!selectedStatus && !activeSearch.term ? "active" : ""}`}
            onClick={handleClearSearch}
          >
            الكل
          </button>
          {Object.entries(ORDER_STATUS_ARABIC).map(([key, value]) => (
            <button
              key={key}
              type="button"
              className={`chip ${selectedStatus === key ? "active" : ""}`}
              onClick={() => handleStatusSearch(key)}
            >
              {value}
            </button>
          ))}
        </div>
      </form>
    </div>
      {loading ? (
        <div className="orders-loading">
          <div className="loading-icon"></div>
          جارٍ تحميل البيانات...
        </div>
      ) : error ? (
        <div>حدث خطأ أثناء جلب البيانات ⚠️</div>
      ) : (
        <div className="table-wrapper">
          <table className="orders-table">
            <thead>
              <tr>
                <th>رقم الطلب</th>
                <th>الاسم</th>
                <th>رقم الهاتف</th>
                <th>الموقع</th>
                <th>الصنف</th>
                <th>الحالة</th>
              </tr>
            </thead>
            <tbody>
              {orders.length > 0 ? (
                orders.map((order) => (
                  <tr
                    key={order.id}
                    onClick={() => handleRowClick(order.id)}
                    style={{ cursor: "pointer" }}
                    className={order.priority ? "priority-row" : ""}
                  >
                    <td>{order.order_no} {order.priority && <span className="priority-badge">مهم</span>}</td>
                    <td>{order.name}</td>
                    <td>{order.phone}</td>
                    <td>{order.location}</td>
                    <td title={getOrderCategoriesTitle(order)}>
                      {getOrderCategoriesTableLabel(order)}
                    </td>
                    <td>{ORDER_STATUS_ARABIC[order.status]}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>لا توجد نتائج</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <button
        type="button"
        className="print-orders-btn"
        onClick={handlePrint}
        disabled={loading || error || orders.length === 0}
      >
        <FaPrint />
        طباعة
      </button>
      {totalPages > 0 && (
            <div className="pagination-container">
              <button
                className="page-btn"
                onClick={() => handlePageChange("prev")}
                disabled={currentPage <= 1}
              >
                &#10094; السابق
              </button>
              
              <div className="page-info">
                صفحة <span className="page-number">{currentPage}</span> من <span className="page-number">{totalPages}</span>
              </div>

              <button
                className="page-btn"
                onClick={() => handlePageChange("next")}
                disabled={currentPage >= totalPages}
              >
                التالي &#10095;
              </button>
            </div>
          )}
    </div>
  );
}

export default Orders;
